import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { uiStateSelector } from 'state/selectors/ui-state';
import moment from 'moment';
import useDoraFeatureFlags from '../../hooks/useDoraFeatureFlags';
import { SEARCH_DATE_FORMAT } from '@linearb/linui-utils';

export function useDefaultDateRange() {
  const { isAllControbutorsTeamSelected } = useDoraFeatureFlags();
  const uiState = useSelector(uiStateSelector);
  const {
    dates: { from, to }
  } = uiState;

  return useMemo(() => {
    if (isAllControbutorsTeamSelected) {
      return {
        from: moment().subtract(30, 'days').format(SEARCH_DATE_FORMAT),
        to: moment().format(SEARCH_DATE_FORMAT)
      };
    }

    return { from, to };
  }, [isAllControbutorsTeamSelected]);
}
